import type { ReactNode } from "react";
import { MarketingFooter } from "./MarketingFooter";
import { MarketingNav } from "./MarketingNav";
import styles from "./ContentPage.module.css";

export interface ContentPageProps {
  /** Short uppercase label rendered above the title. */
  kicker?: string;
  /** Main page heading. */
  title: string;
  /** Optional one-line summary rendered under the title. */
  lead?: string;
  /** Optional "Last updated …" line rendered in the header. */
  lastUpdated?: string;
  /** Prose body. Wrapped in a readable, scoped container. */
  children: ReactNode;
}

/**
 * Shared marketing/content layout: site nav, a readable prose container, and
 * the site footer. Used by the About, Security, and legal pages so they share
 * chrome and typography.
 */
export function ContentPage({ kicker, title, lead, lastUpdated, children }: ContentPageProps) {
  return (
    <>
      <MarketingNav />

      <main className={styles.main}>
        <header className={styles.hero}>
          <div className={styles.heroInner}>
            {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
            <h1 className={styles.title}>{title}</h1>
            {lead ? <p className={styles.lead}>{lead}</p> : null}
            {lastUpdated ? <p className={styles.updated}>Last updated {lastUpdated}</p> : null}
          </div>
        </header>

        <article className={styles.body}>
          <div className={styles.prose}>{children}</div>
        </article>
      </main>

      <MarketingFooter />
    </>
  );
}

export default ContentPage;
